// blog data

export const Blogs = [
  {
    id: 1,
    name: "Comprendre le Web",
    tags: ["Définir le web et ses origines", "gsap", "styled-components"],
    date: "16/09/2020",
    imgSrc:
      "https://th.bing.com/th/id/OIP.m2yQ-Mbv88NIZMn0naBWMAHaEK?w=329&h=185&c=7&r=0&o=5&dpr=1.1&pid=1.7",
    link: "https://dev.to/codebucks/build-website-with-reactjs-styled-components-and-gsap-for-scrolling-animations-2f10",
  },
  {
    id: 2,
    name: "Mettez en place un système de veille informationnelle",
    tags: [
      "Définir vos objectifs de veille",
      "Identifier des sources d'information",
    ],
    date: "19/10/2020",
    imgSrc:
      "https://course.oc-static.com/courses/4805776/4805776_teaser_picture_1614765255.jpg",
    link: "https://codebucks.hashnode.dev/react-hamburger-menu",
  },
  {
    id: 3,
    name: "Découvrez les métiers de développeur",
    tags: ["react", "react-lottie", "styled-components"],
    date: "18/09/2020",
    imgSrc:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaEJd_UCUGcsYyNg0SfCQ5bsfEUZdmySOQX35usr_d6rIIEI9ut1VL1BXekTTPXySNU9Q&usqp=CAU",
    link: "https://codebucks.hashnode.dev/react-loading-screens",
  },
  {
    id: 4,
    name: "Découvrez le fonctionnement des algorithmes",
    tags: ["POO", "Algorythmie", "Javascript"],
    date: "29/12/2020",
    imgSrc:
      "https://course.oc-static.com/courses/4366701/4366701_teaser_picture_1614871924.jpg",
    link: "https://dev.to/codebucks/build-redux-react-todo-list-app-with-animations-using-framer-motion-1mp1",
  },
  {
    id: 5,
    name: "Apprenez à créer votre site web avec HTML5 et CSS3",
    tags: ["Html", "Css"],
    date: "16/09/2020",
    imgSrc:
      "https://course.oc-static.com/courses/1603881/1603881_teaser_picture_1635955233.jpg",
    link: "https://codebucks.hashnode.dev/what-is-higher-order-component",
  },
  {
    id: 6,
    name: "Simplifiez-vous le CSS avec Sass",
    tags: ["Sass"],
    date: "13/12/2020",
    imgSrc:
      "https://course.oc-static.com/courses/6106181/6106181_teaser_picture_1618818510.jpg",
    link: "https://codebucks.hashnode.dev/pagination-in-react",
  },

  {
    id: 7,
    name: "Créez des animations CSS modernes",
    tags: ["css"],
    date: "13/12/2020",
    imgSrc:
      "https://course.oc-static.com/courses/5919246/5919246_teaser_picture_1614872079.jpg",
    link: "https://dev.to/codebucks/what-is-redux-simply-explained-2ch7",
  },
  {
    id: 8,
    name: "Améliorez l'impact de vos présentations",
    tags: [
      "techniques de storytelling ",
      "Construire une présentation ",
      "Créer et suivre une charte graphique",
    ],
    date: "21/10/2020",
    imgSrc:
      "https://i.vimeocdn.com/video/1296324699-643ad15c8afa66e9dcd167d24edd924989c3091a504a5aa86?mw=1100&mh=619&q=70",
    link: "https://dev.to/codebucks/build-sidebar-navigation-menu-in-reactjs-with-react-router-and-framer-motion-for-cool-page-transition-effects-4bc3",
  },
  {
    id: 9,
    name: "Apprenez à utiliser la ligne de commande dans un terminal",
    tags: ["terminal"],
    date: "30/09/2020",
    imgSrc:
      "https://course.oc-static.com/courses/6173491/6173491_teaser_picture_1614872096.jpg",
    link: "https://dev.to/codebucks/build-sidebar-navigation-menu-in-reactjs-with-react-router-and-framer-motion-for-cool-page-transition-effects-4bc3",
  },
  {
    id: 10,
    name: "Apprenez à programmer avec JavaScript",
    tags: ["Javascrip"],
    date: "28/12/2020",
    imgSrc:
      "https://course.oc-static.com/courses/6175841/6175841_teaser_picture_1617092189.jpg",
    link: "https://dev.to/codebucks/build-sidebar-navigation-menu-in-reactjs-with-react-router-and-framer-motion-for-cool-page-transition-effects-4bc3",
  },
  {
    id: 11,
    name: "Découpez et intégrez une maquette",
    tags: ["photoshop", "Css", "Html"],
    date: "27/10/2020",
    imgSrc:
      "https://i.vimeocdn.com/video/781996252-5e6d763e851227f8e924a7687f4436e620d59df74d660d848733312b6eccd696-d?mw=1300&mh=731&q=70",
    link: "https://dev.to/codebucks/build-sidebar-navigation-menu-in-reactjs-with-react-router-and-framer-motion-for-cool-page-transition-effects-4bc3",
  },
  {
    id: 12,
    name: "Gérez du code avec Git et GitHub",
    tags: ["Git", "GitHub"],
    date: "16/03/2021",
    imgSrc:
      "https://i.vimeocdn.com/video/1081761958-2c0954a8e7eea839c255193cf306ac97e2ff5dc0237630bf22434063517350be-d?mw=1100&mh=619&q=70",
    link: "https://dev.to/codebucks/build-sidebar-navigation-menu-in-reactjs-with-react-router-and-framer-motion-for-cool-page-transition-effects-4bc3",
  },
  {
    id: 13,
    name: "Testez l'interface de votre site",
    tags: [" méthodes BDD et TDD", "Jasmine", "Écrire des tests"],
    date: "19/12/2021",
    imgSrc:
      " https://course.oc-static.com/courses/3504461/3504461_teaser_picture_1614871898.jpg",
    link: "https://dev.to/codebucks/build-sidebar-navigation-menu-in-reactjs-with-react-router-and-framer-motion-for-cool-page-transition-effects-4bc3",
  },
];
